export default `import React from "react";
import {Button} from 'zapify-ui';

function Button(props) {
  return (
    <div>
    <Button color="primaryButton"> Hello </Button>
    </div>
  );
}
export default Button;`;